export class ResourceLoader {
	scriptsQueue = [];
	alreadyLoadedResources = [];
	forceLoadedResources = [];

	setForceLoadedResources(forceLoadedResources = []) {
		this.forceLoadedResources = forceLoadedResources;
	}

	loadScripts(cb) {
		if (this.scriptsQueue.length === 0) {
			if (cb) {
				cb();
			}
			return;
		}
		const script = document.createElement('script');
		script.setAttribute('src', this.scriptsQueue.shift());
		script.addEventListener('load', () => {
			this.loadScripts(cb);
		});
		document.body.appendChild(script);
	}

	scheduleScript(src) {
		if (
			!src ||
			(this.alreadyLoadedResources.indexOf(src) >= 0 && this.forceLoadedResources.indexOf(src) === -1)
		) {
			return;
		}
		this.alreadyLoadedResources.push(src);
		this.scriptsQueue.push(src);
	}

	insertStylesheet(stylesheet) {
		const link = document.createElement('link');
		link.setAttribute('rel', 'stylesheet');
		link.setAttribute('type', 'text/css');
		link.setAttribute('media', 'all');
		link.setAttribute('href', stylesheet);
		if (this.alreadyLoadedResources.indexOf(stylesheet) >= 0) {
			return;
		}
		this.alreadyLoadedResources.push(stylesheet);

		document.body.appendChild(link);
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/utils/resource-loader.js